





















import { Component, Prop, Vue } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';

@Component({
  name: 'BaseDatepicker',
  components: {
    Datepicker,
  },
})
export default class BaseDatepicker extends Vue {
  @Prop() placeholder: string;
  @Prop() format: string;
  @Prop() maximumView: string;
  @Prop() minimumView: string;
  @Prop() value: string;
  @Prop() label: string;

  get inputId(): string {
    return `input-${this['_uid']}`;
  }
  handleSelect(date: string) {
    this.$emit('select', date);
  }
}
